var _style, _line, _line2, _line3, _line4, _line5, _line6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoaderAnimation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1,
    stroke: "currentColor",
    fill: "none",
    viewBox: "0 0 24 24",
    height: 48,
    width: 48,
    className: "svg-loader",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .svg-loader {animation: loader 2s linear infinite;}\n    @keyframes loader {\n      0% {color: var(--bs-primary);}\n      25% {color: var(--bs-accent);}\n      50% {color: var(--bs-accent-4); transform: rotate(360deg);}\n      75% {color: var(--bs-accent-2);}\n      100% {color: var(--bs-primary); transform: rotate(720deg);}\n    }\n  ")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y2: 6,
    x2: 12,
    y1: 2,
    x1: 12
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y2: 22,
    x2: 12,
    y1: 18,
    x1: 12
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 20.660255,
    y1: 6.9999995,
    x2: 17.196154,
    y2: 9
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 6.8038473,
    y1: 15,
    x2: 3.3397458,
    y2: 17
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y2: 8.999999,
    x2: 6.8038478,
    y1: 6.9999995,
    x1: 3.3397462
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y2: 17,
    x2: 20.660255,
    y1: 15,
    x1: 17.196154
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderAnimation);
export default __webpack_public_path__ + "static/media/loader-animation.78cbae5ae2b02844f5f20e5a169f802a.svg";
export { ForwardRef as ReactComponent };